import { IsEnum, IsNotEmpty, IsNumber, IsOptional } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
import { DeviceTypeEnum, DeviceStatusEnum } from '@gtpl/shared-models/masters';
export class DeviceDto {
    @ApiProperty()
    @IsNotEmpty({ message: "Plant Id should not be empty" })
    @IsNumber()
    plantId: number;

    @ApiProperty()
    @IsNotEmpty({ message: "Device Name should not be empty" })
    deviceName: string;

    @ApiProperty({
        enum: DeviceTypeEnum,
        default: DeviceTypeEnum.HAND_HELD
    })
    @IsNotEmpty({ message: "Device Type should not be empty" })
    @IsEnum(DeviceTypeEnum)
    deviceType: DeviceTypeEnum;

    @ApiProperty()
    @IsNotEmpty({ message: "Device Mac Id should not be empty" })
    deviceMacId: string;

    @ApiProperty({
        enum: DeviceStatusEnum,
        default: DeviceStatusEnum.ONLINE
    })
    @IsNotEmpty({ message: "Device Type should not be empty" })
    @IsEnum(DeviceStatusEnum)
    deviceStatus: DeviceStatusEnum;
  
    @ApiProperty()
    @IsOptional()
    createdUser: string;
}